import React, { useEffect, useRef, useState } from 'react';
import WaveSurfer from 'wavesurfer.js';
import { Play, Pause, SkipBack, SkipForward } from 'lucide-react';
import { baseURL } from '@/config/config';

interface WaveFormProps {
    url: string;
}

const WareForm = ({ url }: WaveFormProps) => {
    const waveformRef = useRef<HTMLDivElement>(null);
    const wavesurfer = useRef<WaveSurfer | null>(null);
    const [playing, setPlaying] = useState(false);
    const [duration, setDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);

    useEffect(() => {
        const fetchAudio = async () => {
            try {
                // Destroy existing instance if any
                if (wavesurfer.current) {
                    wavesurfer.current.destroy();
                }

                let key = "";
                let isAws = false;

                if (url.startsWith('https://viyume-media.s3.ap-southeast-1.amazonaws.com')) {
                    const urlPath = url.split('?')[0];
                    key = urlPath.split('uploads/')[1];
                    isAws = true;
                } else {
                    key = url;
                }

                const response = await fetch(`${baseURL}/media/audio/${encodeURIComponent(key)}/${isAws}`);
                const blob = await response.blob();
                const audioUrl = URL.createObjectURL(blob);

                if (waveformRef.current && !wavesurfer.current) {
                    wavesurfer.current = WaveSurfer.create({
                        container: waveformRef.current,
                        waveColor: '#4a9eff',
                        progressColor: '#1e429f',
                        cursorColor: '#1e429f',
                        barWidth: 2,
                        barRadius: 3,
                        cursorWidth: 1,
                        height: 50,
                        barGap: 3,
                        normalize: true,
                        splitChannels: false,
                        mediaControls: false,
                        backend: 'WebAudio',
                        responsive: true,
                        hideScrollbar: true,
                        plugins: []
                    });

                    wavesurfer.current.load(audioUrl);

                    wavesurfer.current.on('ready', () => {
                        setDuration(wavesurfer.current?.getDuration() || 0);
                    });

                    wavesurfer.current.on('audioprocess', () => {
                        setCurrentTime(wavesurfer.current?.getCurrentTime() || 0);
                    });

                    wavesurfer.current.on('finish', () => {
                        setPlaying(false);
                    });
                }
            } catch (error) {
                console.error('Error loading audio:', error);
            }
        };

        fetchAudio();

        return () => {
            if (wavesurfer.current) {
                wavesurfer.current.destroy();
            }
        };
    }, [url]);

    const formatTime = (time: number) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    };

    const handlePlayPause = () => {
        if (wavesurfer.current) {
            wavesurfer.current.playPause();
            setPlaying(!playing);
        }
    };

    // const handleRewind = () => {
    //     if (wavesurfer.current) {
    //         const currentTime = wavesurfer.current.getCurrentTime();
    //         wavesurfer.current.seekTo((currentTime - 5) / wavesurfer.current.getDuration());
    //     }
    // };

    // const handleForward = () => {
    //     if (wavesurfer.current) {
    //         const currentTime = wavesurfer.current.getCurrentTime();
    //         wavesurfer.current.seekTo((currentTime + 5) / wavesurfer.current.getDuration());
    //     }
    // };

    return (
        <div className="w-full space-y-4">
            <div ref={waveformRef} className="w-full" />
            
            <div className="flex items-center justify-between px-4">
                <span className="text-sm text-gray-500">
                    {formatTime(currentTime)}
                </span>
                
                <div className="flex items-center gap-4">
                    {/* <button
                        onClick={handleRewind}
                        className="p-2 hover:bg-gray-100 rounded-full"
                    >
                        <SkipBack className="w-5 h-5" />
                    </button>
                     */}
                    <button
                        onClick={handlePlayPause}
                        className="p-3 bg-blue-500 hover:bg-blue-600 rounded-full text-white"
                    >
                        {playing ? (
                            <Pause className="w-6 h-6" />
                        ) : (
                            <Play className="w-6 h-6" />
                        )}
                    </button>
                    
                    {/* <button
                        onClick={handleForward}
                        className="p-2 hover:bg-gray-100 rounded-full"
                    >
                        <SkipForward className="w-5 h-5" />
                    </button> */}
                </div>
                
                <span className="text-sm text-gray-500">
                    {formatTime(duration)}
                </span>
            </div>
        </div>
    );
};

export default WareForm;